import type {ISonuc} from "@/model/sonuc";
import ApiService from "./api";
import LogService, {LogIslem, LogSayfa} from "./log";
import {type ISonucDto, mapSonucFromDTO} from "@/model/sonuc.dto";
import {type ISoruDTO, mapSoruFromDTO} from "@/model/yarisma.dto.ts";
import type {ISoru} from "@/model/yarisma.ts";

export class SonucService {
    static async getSonuc() {
        const startTime = performance.now();
        const [err, resp] = await ApiService.get<ISonucDto>("sonuc");
        if (err) {
          LogService.log(LogSayfa.ANASAYFA, LogIslem.HATA, {
            err,
                resp,
                delay: performance.now() - startTime
            });
            return [err, {} as ISonuc];
        }
        return [null, mapSonucFromDTO(resp!.data)];
    }

    static async getSoruCevaplar() {
        const startTime = performance.now();
        const [err, resp] = await ApiService.get<ISoruDTO[]>("sonuc/sorular");
        if (err) {
          LogService.log(LogSayfa.ANASAYFA, LogIslem.HATA, {
            err,
                resp,
                delay: performance.now() - startTime
            });
            return [err, [] as ISoru[]];
        }
        return [null, mapSoruFromDTO(resp!.data)];
    }
}
